import styled from '@emotion/styled';
import css from '@styled-system/css';

import { Flex } from '../../layouts';

const OverlayFooter = styled(Flex)(
  css({
    p: 4,
  })
);

export default OverlayFooter;
